import {Component, Input, OnInit, OnChanges, OnDestroy} from '@angular/core';
import { Store, Select } from '@ngxs/store';
import {PanelOutputGroup} from '../../../core/models/panel-output-group';
import {PanelOutput} from '../../../core/models/panel-output.interface';
import {TableColumn} from '../../../core/models/table-column';
import { SelectPanelOutputGroup, ResetCommandsMessages } from '../../../core/store/panel-outputs/panel-outputs.actions';
import {Observable, Subject} from 'rxjs';
import { PanelOutputsStateSelectors } from '../../../core/store/panel-outputs/panel-outputs.selectors';
import { SharedState } from '../../../core/store/shared/shared.state';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-grouped-list',
  templateUrl: './grouped-list.component.html',
  styleUrls: ['./grouped-list.component.scss']
})
export class GroupedPanelOutsputsComponent implements OnInit, OnChanges, OnDestroy {
  @Select(PanelOutputsStateSelectors.userPanelOutputs) outputs$: Observable<PanelOutput[]>;
  @Select(PanelOutputsStateSelectors.userPanelOutputGroups) outputGroups$: Observable<PanelOutputGroup[]>;
  @Select(PanelOutputsStateSelectors.selectedGroup) selectedGroup$: Observable<PanelOutputGroup>;
  @Select(SharedState.isDarkTheme) isDarkTheme$: Observable<boolean>;

  @Input() isGroupDisplay: boolean;

  displayGroups: PanelOutputGroup[] = [];
  groupsColumns: TableColumn[] = [{ code: 'type', label: 'Type' }, { code: 'name', label: 'Name' }, { code: 'accessArea', label: 'Access Area' }, { code: 'outputGroupName', label: 'Group' }, { code: 'status', label: 'Locking Status' }, { code: 'monitorStatus', label: 'Opening Status' }];
  flatListColumns: TableColumn[] = [{ code: 'type', label: 'Type' }, { code: 'name', label: 'Name' }, { code: 'accessArea', label: 'Access Area' }, { code: 'status', label: 'Locking Status' }, { code: 'monitorStatus', label: 'Opening Status' }];
  columnsToDisplay: TableColumn[];
  selectedGroup: PanelOutputGroup;
  private destroy$ = new Subject<boolean>();

  constructor(private store: Store) { }

  ngOnInit() {
    this.selectedGroup$
      .pipe(takeUntil(this.destroy$))
      .subscribe(group => {
        this.selectedGroup = group ? group : null;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnChanges() {
    this.columnsToDisplay = this.isGroupDisplay ? this.groupsColumns : this.flatListColumns;
  }


  selectGroup(group: PanelOutputGroup, e) {
    if (e.target.id !== 'expansion-toggle-button') {
      this.resetMessages();
      this.isGroupSelected(group) ? this.store.dispatch(new SelectPanelOutputGroup(null)) : this.store.dispatch(new SelectPanelOutputGroup(group));
    }

  }

  isGroupSelected(group: PanelOutputGroup) {
    if (this.selectedGroup) {
      return this.selectedGroup.id === group.id;
    } else {
      return false;
    }
  }

  resetMessages() {
    this.store.dispatch(new ResetCommandsMessages());
  }

  test(panel, group) {
    panel.toggle();
  }

}
